import { MensagemTipo } from './mensagem-tipo.enum';

export default class Mensagem {
  texto?: string;
  tipo?: MensagemTipo;
}
